import { toE164 } from '@/lib/phone/usPhone';
import type { ConsentDecision, SubmitConsentsBody } from '@/lib/api/consents/types';
import type { ConsentPrompt } from './deriveConsentPrompt';
import { isChecked, type ConsentFormValues } from './formValues';

export const buildSubmitPayload = (
  prompt: Extract<ConsentPrompt, { kind: 'prompt' }>,
  values: ConsentFormValues
): SubmitConsentsBody => {
  const decisions: ConsentDecision[] = [];

  for (const consentType of prompt.missing) {
    const checked = isChecked(consentType, values);
    const response = checked ? 'YES' : 'NO';
    if (consentType === 'ELECTRONIC_DELIVERY' && !checked) continue;

    const contactAtConsent =
      consentType !== 'ELECTRONIC_DELIVERY' && values.mobilePhone
        ? (toE164(values.mobilePhone) ?? undefined)
        : undefined;

    decisions.push({
      consentType,
      response,
      ...(contactAtConsent ? { contactAtConsent } : {}),
    });
  }

  return {
    source: 'OLA_CLICK_THROUGH_MODAL',
    decisions,
  };
};
